"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncWithGlobalTree = void 0;
const react_1 = require("react");
const product_tree_1 = require("../client/product-tree");
const store_1 = require("../../store");
const useSyncWithGlobalTree = ({ selectedCatalogId, skip }) => {
    var _a, _b;
    const productTreeId = (0, store_1.useProductTreeId)();
    const { hasGlobalTreeWritePermission, globalTreeId, loading: permissionLoading, } = (0, product_tree_1.useHasGlobalTreeWritePermission)({ skip });
    const { syncProductTree, isSyncing } = (0, product_tree_1.useSyncProductTree)();
    const { data: catalogProductTree, isInitialLoading: catalogTreeLoading, } = (0, product_tree_1.useCatalogProductTree)(selectedCatalogId);
    const lastSyncTimestamp = (_a = catalogProductTree === null || catalogProductTree === void 0 ? void 0 : catalogProductTree.lastSyncedAt) !== null && _a !== void 0 ? _a : null;
    const isLinkedToParent = (_b = catalogProductTree === null || catalogProductTree === void 0 ? void 0 : catalogProductTree.isLinkedToParent) !== null && _b !== void 0 ? _b : false;
    const isCatalogLinkedToLocalCopy = Boolean(productTreeId && globalTreeId && productTreeId !== globalTreeId);
    const showSyncButton = !skip
        && !permissionLoading
        && !catalogTreeLoading
        && hasGlobalTreeWritePermission
        && isCatalogLinkedToLocalCopy;
    const handleSync = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield syncProductTree(productTreeId, isLinkedToParent);
    }), [syncProductTree, productTreeId, isLinkedToParent]);
    return {
        showSyncButton, lastSyncTimestamp, isSyncing, handleSync,
    };
};
exports.useSyncWithGlobalTree = useSyncWithGlobalTree;
